module.exports = __webpack_public_path__ + "img/aboutUs4.6789098.png";